import React from 'react';

const SOURCE_LABELS = {
  template: 'Template',
  practice_a: 'Practice A',
  practice_b: 'Practice B',
};

const pct = (value) => `${Math.round((Number(value || 0) * 100))}%`;

const MergeCoverageBar = ({ mergeQuality }) => {
  if (!mergeQuality || typeof mergeQuality !== 'object') {
    return null;
  }

  const sources = mergeQuality.sources || {};
  const sourceKeys = Object.keys(sources);
  const warning = Boolean(mergeQuality.warning);

  return (
    <section className="merge-coverage panel panel--spaced">
      <div className="merge-coverage__header">
        <h3>Merge Coverage</h3>
        <span className={`status-pill ${warning ? 'status-pill--error' : 'status-pill--complete'}`}>
          {warning ? 'Review Needed' : 'Coverage OK'}
        </span>
      </div>
      <p className="muted">
        Merged words: <strong>{mergeQuality.merged_word_count || 0}</strong> | Longest source words:{' '}
        <strong>{mergeQuality.longest_source_word_count || 0}</strong> | Overall coverage:{' '}
        <strong>{pct(mergeQuality.overall_coverage_score)}</strong>
      </p>
      {warning && mergeQuality.warning_reason && (
        <p className="alert merge-coverage__warning">{mergeQuality.warning_reason}</p>
      )}
      {sourceKeys.length > 0 && (
        <div className="merge-coverage__sources">
          {sourceKeys.map((key) => {
            const source = sources[key] || {};
            return (
              <div key={key} className="merge-coverage__source">
                <div className="merge-coverage__source-row">
                  <span>{SOURCE_LABELS[key] || key}</span>
                  <span>{pct(source.coverage_score)}</span>
                </div>
                <div className="merge-coverage__track" aria-hidden="true">
                  <span className="merge-coverage__fill" style={{ width: pct(source.coverage_score) }} />
                </div>
                <p className="muted">
                  Headings: {source.section_headings_matched || 0}/{source.section_headings_total || 0} | Source words:{' '}
                  {source.source_word_count || 0}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default MergeCoverageBar;
